const storeName = 'checkout';
export default {
    SET_STORED_ADDRESS: `${storeName}.SET_STORED_ADDRESS`,
    SELECT_STORE: `${storeName}.SELECT_STORE`,
    SET_DELIVERY_TIME_SLOTS: `${storeName}.SET_DELIVERY_TIME_SLOTS`,
    SET_PROGRESS_BAR_ID: `${storeName}.SET_PROGRESS_BAR_ID`,
    SHIPPING_BLOCKED: `${storeName}.SHIPPING_BLOCKED`,
    SET_DELIVERY_MODE: `${storeName}.SET_DELIVERY_MODE`,
    SET_DELIVERY_ADDRESS: `${storeName}.SET_DELIVERY_ADDRESS`,
    PUT_DELIVERY_ADDRESS: `${storeName}.PUT_DELIVERY_ADDRESS`,
    DELIVERY_ADDRESS_ERROR: `${storeName}.DELIVERY_ADDRESS_ERROR`,
    CLEAR_DELIVERY_MODE: `${storeName}.CLEAR_DELIVERY_MODE`,
    APPLY_DELIVERY_POST_POINT: `${storeName}.APPLY_DELIVERY_POST_POINT`,
    SET_CHANGE_DELIVERY_ADDRESS: `${storeName}.SET_CHANGE_DELIVERY_ADDRESS`,
    GO_TO_FREE_SAMPLES: `${storeName}.GO_TO_FREE_SAMPLES`,
    SET_ADDRESS_FOR_BILLING: `${storeName}.SET_ADDRESS_FOR_BILLING`,
    SAGA_SET_ADDRESS_FOR_BILLING: `${storeName}.SAGA_SET_ADDRESS_FOR_BILLING`,
    CHECK_REDIRECT: `${storeName}.CHECK_REDIRECT`,
    SET_USE_DELIVERY_AS_BILLING: `${storeName}.SET_USE_DELIVERY_AS_BILLING`,
    CLEAR_DELIVERY_MODE_ON_PAYMENT_STEP: `${storeName}.CLEAR_DELIVERY_MODE_ON_PAYMENT_STEP`,
    EMPTY_DELIVERY_ADDRESS: `${storeName}.EMPTY_DELIVERY_ADDRESS`,
    CHANGE_DELIVERY_ADDRESS: `${storeName}.CHANGE_DELIVERY_ADDRESS`,
    DELIVERY_MODE_REDIRECT: `${storeName}.DELIVERY_MODE_REDIRECT`,
    HIDE_DELIVERY_ADDRESS: `${storeName}.HIDE_DELIVERY_ADDRESS`,
    SHIPPING_COUNTDOWN_ENDED: `${storeName}.SHIPPING_COUNTDOWN_ENDED`,
    SHOW_SHIPPING_COUNTDOWN: `${storeName}.SHOW_SHIPPING_COUNTDOWN`,
    HIDE_SHIPPING_COUNTDOWN: `${storeName}.HIDE_SHIPPING_COUNTDOWN`,
    SAVE_PHONE_NUMBER: `${storeName}.SAVE_PHONE_NUMBER`,
    CHANGE_DELIVERY_ADDRESS_AND_REDIRECT: `${storeName}.CHANGE_DELIVERY_ADDRESS_AND_REDIRECT`,
    CHECK_DELIVERY_ADDRESS: `${storeName}.CHECK_DELIVERY_ADDRESS`,
    DISABLE_PICKUP_EXPRESS_ENTER_PHONE: `${storeName}.DISABLE_PICKUP_EXPRESS_ENTER_PHONE`,
    SHOW_CUSTOM_ERROR_MESSAGE: `${storeName}.SHOW_CUSTOM_ERROR_MESSAGE`,
    ENABLE_PICKUP_EXPRESS_ENTER_PHONE: `${storeName}.ENABLE_PICKUP_EXPRESS_ENTER_PHONE`,
    PAYMENT_REDIRECT: `${storeName}.PAYMENT_REDIRECT`,
};
